
import { DashboardCardDataModel } from '../../api/api.models'

//#region Asset Imports

import './card.scss'
import * as TEMPLATE from './card.tpl.html'

//#endregion

interface CardScope extends ng.IScope {
    id: number
    data: DashboardCardDataModel 
    imageType: string
    isEditMode: boolean 
}

export class CardDirective implements ng.IDirective {
    constructor() {
        
    }
    scope = {
        data: '=',
        itemTitle: '=',
        isEditMode: '='
    }

    controller = ['$scope', ($scope: CardScope) => {        
        if ($scope.data) {
            if ($scope.data.image) {
                if ($scope.data.imageExtension == "Unknown" && $scope.data.image.physicalFileName) {
                    var ext = $scope.data.image.extension
                    if (ext && ext.toLowerCase() == 'svg') $scope.imageType = 'svg+xml'
                } else if ($scope.data.imageExtension == "Png") {
                    $scope.imageType = 'png'
                } else if ($scope.data.imageExtension == "Svg") {
                    $scope.imageType = 'svg+xml'
                } else {
                    $scope.imageType = 'png'
                }
            }
        }
    }]

    restrict = 'E'
    template = TEMPLATE
    transclude = true
    replace = true    
}